const LOCAL_USER = localStorage.getItem('PCBCART_LIVE_CHAT') ? JSON.parse(localStorage.getItem('PCBCART_LIVE_CHAT')) : {}
const state = {
    name: 'client chat',
    init: false,
    open_modal: false,
    open_message: false,
    server_time: null,
    user: {
        uuid: LOCAL_USER.uuid || null,
        name: '',
        email: '',
        user_role: 'user',
        client_id: null,
    },
    done: false,
    error: false,
    show_tip: false,
    app_status: 'open',
    window_user: null,
    no_admin_online: true,
    super_admin_online: [],
    tip_object: {}
}

const getters = {   
    
}

const mutations = {
    SOCKET_ONOPEN() {
        console.log('socket open')
    },
    SOCKET_ONCLOSE() {
        console.log('socket close')
    },
    SOCKET_ONERROR() {
        console.log('socket onerror')
    },
    SOCKET_ONMESSAGE(state, payload) {
        console.log('socket onmessage', payload)
    },
    SOCKET_ON_ping(state, payload) {
        console.log('ping', payload)
    },
    initApp (state) {
        state.init = true
    },
    initUser (state, payload) {
        window.localStorage.setItem('PCBCART_LIVE_CHAT', JSON.stringify(payload))
        state.user = payload
    },
    syncServerTime (state, payload) {
        state.server_time = payload
    },
    switchModal(state) {
        state.open_modal = !state.open_modal
    },
    openMessage(state) {
        state.open_message = true
    },
    closeMessage(state) {
        state.open_message = false
    },
    updateUser(state, payload) {
        let user = state.user
        state.user = Object.assign(state.user, payload)
    },
    updateTip(state, payload) {
        state.tip_object = payload
    },
    showTip(state) {
        state.show_tip = true
    },
    closeTip(state) {
        state.show_tip = false
    },
    updateAppStatus(state, payload) {
        state.app_status = payload
    },
    updateWindowUser(state, payload) {
        state.window_user = payload
    },
    updateSuperAdminOnline(state, payload) {
        state.super_admin_online = payload
    },
    updateNoAdminOline(state, payload) {
        state.no_admin_online = payload
    }
}

const actions = {
    init ({commit, state}, payload) {
        setTimeout(() => {
            commit('initApp')
            commit('initUser', payload.user)
            commit('syncServerTime', payload.server_time)
        }, 1200)
    },
    updateNoAdminOlineStatus({commit, state}, payload) {
        commit('updateNoAdminOline', payload)
        setTimeout(() => {
            commit('updateNoAdminOline', !payload)
        }, 5 * 60 * 1000)
    } 
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/state.js